import React, { useEffect } from "react"

import { screenAbout } from "@app/@signals"
import AppInfoButton from "@components/@base/InfoButton"
import { askIrisAllowed } from "./AskIrisButton"
import useScreenHelp from "./useScreenHelp"

/**
 * "About this screen" (CU-869fmufdb, UX C8): one help per header. While the Ask Iris help icon is painted (Iris for
 * this user and a help page for this screen, whatever Iris's state), the page's ⓘ is not: its text becomes the
 * icon's tooltip, published in `screenAbout` and cleared on unmount. Otherwise it is today's `AppInfoButton`.
 * Same props as `AppInfoButton`; one copy of each text.
 */
export default function ScreenAbout({ title, children, ...infoProps }) {
	const help = useScreenHelp()
	const visible = askIrisAllowed() && help !== null

	useEffect(() => {
		if (!visible) return undefined
		const about = { title, content: children }
		screenAbout.value = about
		return () => { if (screenAbout.value === about) screenAbout.value = null }
	}, [visible, title, children])

	if (visible) return null
	return <AppInfoButton title={title} {...infoProps}>{children}</AppInfoButton>
}
